__webpack_require__.p = "/dev/text-details-and-qualif/";